import React, {FormEvent, useState} from "react";
import {
    Box,
    Button,
    Typography,
    Alert,
} from "@mui/material";
import {TextInput} from "../components/form/TextInput";
import {resetPassword} from "../service/auth.service";
import {enqueueSnackbar} from "notistack";
import {useNavigate, useParams} from "react-router";
import {useAuthStore} from "../store/auth.store";


export function PasswordResetForm() {
    const {id: resetPasswordId} = useParams();
    const [password, setPassword] = useState("");
    const [repeatPassword, setRepeatPassword] = useState("");
    const [error, setError] = useState("");
    const authStore = useAuthStore();
    const navigate = useNavigate();


    const handleSubmit = (e:FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError("");


        if (!password || !repeatPassword) {
            setError("Please fill in both password fields.");
            return;
        }


        if (password.length < 8) {
            setError("Password must be at least 8 characters long.");
            return;
        }


        if (password !== repeatPassword) {
            setError("Passwords do not match.");
            return;
        }


        resetPassword({
            id: resetPasswordId!,
            password: password
        }).then(response => {
            navigate("/")
            authStore.setUser(response.data.user)
            authStore.setJwt(response.data.jwt);
            authStore.setShowLogin(false);
        }).catch((e) => {
            if(e.status === 404) {
                enqueueSnackbar({message: "Failed to reset password, link expired or not valid.", variant: "error"})
            } else {
                enqueueSnackbar({message: "Failed to reset password " + e.message, variant: "error"})
            }
        })
    };


    return (
                <Box maxWidth={'1000px'} margin={"0 auto"} component="form" onSubmit={handleSubmit} noValidate>
                    <Typography variant="h4" fontWeight={600} gutterBottom>
                        Reset Password
                    </Typography>

                    <Typography variant="body2" color="text.secondary" mb={3}>
                        Please choose a strong new password and confirm it below.
                    </Typography>

                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}

                    <TextInput
                        label="New Password"
                        className={"mb mb-15"}
                        type="password"
                        fullWidth
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />


                    <TextInput
                        label="Repeat Password"
                        className={"mb mb-15"}
                        type="password"
                        fullWidth
                        value={repeatPassword}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        fullWidth
                        sx={{ mt: 3 }}
                    >
                        Set New Password
                    </Button>
                </Box>
    );
}